import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDeactivate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M1.75 9.692a5.06 5.06 0 0 1 5.058-5.058h6.384a5.058 5.058 0 1 1 0 10.116H6.808A5.06 5.06 0 0 1 1.75 9.692m5.058-3.558a3.558 3.558 0 1 0 0 7.116h6.384a3.558 3.558 0 0 0 0-7.116z"
      clipRule="evenodd"
    />
    <path d="M4.654 9.692a2.154 2.154 0 1 1 4.308 0 2.154 2.154 0 0 1-4.308 0" />
  </svg>
);
export default SvgDeactivate;
